export const businessInfo = {
  name: "Harsh R Shah & Associates, Chartered Accountants",
  tagline: "Expert Tax & Compliance Solutions for Growing Businesses",
  phone: "+91-9510960227",
  email: "ca.hrshah@yahoo.com",
  whatsapp: "+91-9510960227",
  address: "B-408, World Trade Tower, Behind Skoda Showroom, SG Highway, Ahmedabad - 380051",
  experience: "12",
  officeHours: "Monday - Saturday: 10:00 AM - 6:00 PM",
  googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.9!2d72.5!3d23.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDAyJzAwLjAiTiA3MsKwMzAnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890",
  profileImage: "/harsh-shah-profile.png",
  founderName: "Harsh R Shah",
  qualification: "Chartered Accountant",
  linkedin: "https://www.linkedin.com/in/cahrshah",
  detailedBio: {
    intro: "Harsh R Shah is a distinguished Chartered Accountant with over 12 years of proven expertise in taxation, audit, and comprehensive business advisory services. With a deep-rooted commitment to excellence and client success, Harsh has established himself as a trusted advisor for individuals, startups, and established enterprises across India.",
    expertise: "Specializing in complex GST compliance, income tax planning, statutory audits, and business structuring, Harsh brings a unique blend of technical mastery and practical business acumen to every engagement. His approach goes beyond mere compliance – he partners with clients to optimize tax positions, streamline financial operations, and drive sustainable business growth.",
    approach: "What sets Harsh apart is his client-centric philosophy and forward-thinking methodology. He believes in proactive compliance management, where potential issues are identified and resolved before they become problems. His clear communication style demystifies complex tax regulations, empowering clients to make informed financial decisions with confidence.",
    vision: "Throughout his career, Harsh has successfully navigated clients through challenging tax scenarios, represented businesses before regulatory authorities, and helped numerous startups establish robust compliance frameworks from day one. His dedication to staying ahead of regulatory changes and leveraging technology for efficient service delivery ensures clients receive cutting-edge solutions.",
    commitment: "Whether you're a startup founder navigating your first tax season, an established business seeking strategic tax planning, or an individual requiring expert representation before tax authorities, Harsh and his team deliver personalized, results-driven solutions that add tangible value to your financial success."
  }
};

export const services = [
  {
    id: 1,
    title: "GST Compliance & Advisory",
    description: "End-to-end GST solutions for seamless compliance. Expert handling of registrations, returns, refunds, appeals, and litigation with proactive advisory to optimize input tax credits.",
    icon: "FileText",
    features: ["GST Registration & Amendments", "Monthly/Quarterly/Annual Returns", "GST Refunds & Appeals", "Input Tax Credit Optimization", "GST Litigation Support", "E-way Bill & E-invoicing"]
  },
  {
    id: 2,
    title: "USA Bookkeeping & Accounting",
    description: "Comprehensive bookkeeping services for US-based businesses. Expert QuickBooks management, financial reconciliation, and compliance support to keep your books accurate and up-to-date.",
    icon: "TrendingUp",
    features: ["QuickBooks Online/Desktop Setup", "Monthly Bookkeeping & Reconciliation", "Financial Statements & Reports", "Accounts Payable/Receivable Management", "Payroll Processing Support", "US Tax Compliance Assistance"]
  },
  {
    id: 3,
    title: "Income Tax Services",
    description: "Comprehensive income tax planning and filing services for individuals, businesses, and professionals with expert litigation support.",
    icon: "Calculator",
    features: ["Tax Planning & Optimization", "ITR Filing (All Forms)", "Tax Litigation & Representation", "TDS/TCS Compliance"]
  },
  {
    id: 4,
    title: "Audit Services",
    description: "Statutory, tax, and internal audits ensuring compliance and accurate financial reporting with thorough examination.",
    icon: "ClipboardCheck",
    features: ["Statutory Audit", "Tax Audit", "Internal Audit", "Stock Audit"]
  },
  {
    id: 5,
    title: "Business Registration",
    description: "Complete assistance in business setup including company incorporation, LLP formation, and all statutory registrations.",
    icon: "Building2",
    features: ["Company Incorporation", "LLP Registration", "Partnership Deed", "MSME Registration"]
  },
  {
    id: 6,
    title: "Notice & Appeals",
    description: "Expert representation before tax authorities for notice replies, assessments, and appeals with successful track record.",
    icon: "Scale",
    features: ["Income Tax Notices", "GST Notice Handling", "Assessment Representation", "Appeals Filing"]
  },
  {
    id: 7,
    title: "Advisory & Consulting",
    description: "Strategic business advisory, financial planning, and compliance consulting for sustainable growth and success.",
    icon: "Lightbulb",
    features: ["Business Advisory", "Financial Planning", "Compliance Review", "Virtual CFO Services"]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "12 Years of Expertise",
    description: "ICAI certified professional with over a decade of experience in tax and compliance",
    icon: "Award"
  },
  {
    id: 2,
    title: "Timely Compliance",
    description: "Never miss a deadline with our systematic approach and proactive reminders",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Transparent Pricing",
    description: "Clear, upfront pricing with no hidden charges or surprises",
    icon: "DollarSign"
  },
  {
    id: 4,
    title: "Personalized Attention",
    description: "Direct access to experienced professionals who understand your business",
    icon: "Users"
  },
  {
    id: 5,
    title: "Practical Solutions",
    description: "Real-world solutions tailored to Indian business environment and regulations",
    icon: "Lightbulb"
  },
  {
    id: 6,
    title: "End-to-End Support",
    description: "Comprehensive services from registration to compliance and representation",
    icon: "Shield"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Patel",
    company: "Textiles Industry",
    text: "Harsh and his team have been managing our GST and tax compliance for 3 years. Their proactive approach has saved us from penalties multiple times. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Mehta",
    company: "Startup Founder",
    text: "As a first-time entrepreneur, I was confused about compliances. Harsh R Shah provided clear guidance on company incorporation and ongoing compliance. Very professional service.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Shah",
    company: "Real Estate Professional",
    text: "I was facing an income tax notice and was worried. Harsh handled the matter professionally and got it resolved without any penalty. Grateful for their expertise.",
    rating: 5
  },
  {
    id: 4,
    name: "Neha Desai",
    company: "E-commerce Business",
    text: "Managing GST for multi-state sales was complex. Their team simplified everything and ensures timely filing every month. Peace of mind is priceless!",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What services do you provide?",
    answer: "We provide comprehensive tax and compliance services including GST, Income Tax, Audits, Business Registration, Notice Replies, and Business Advisory for individuals, startups, and established businesses."
  },
  {
    id: 2,
    question: "How much do you charge for ITR filing?",
    answer: "Our fees depend on the complexity of your income sources. For salaried individuals, ITR filing starts from ₹500. For business income, fees vary based on turnover and complexity. Contact us for a detailed quote."
  },
  {
    id: 3,
    question: "Do you handle tax notices and appeals?",
    answer: "Yes, we have extensive experience in handling income tax and GST notices, assessments, and appeals. We represent clients before tax authorities and provide expert documentation support."
  },
  {
    id: 4,
    question: "How long does company incorporation take?",
    answer: "Typically, company incorporation takes 7-15 working days from submission of complete documents, subject to government processing. We handle the entire process including DSC, DIN, and filing."
  },
  {
    id: 5,
    question: "Do you provide services outside Ahmedabad?",
    answer: "Yes, we serve clients across India. Most compliance work can be managed remotely. For complex matters requiring in-person meetings, we can arrange video consultations or travel as needed."
  },
  {
    id: 6,
    question: "What documents do I need for GST registration?",
    answer: "Basic documents include PAN card, Aadhaar, business address proof, bank statement/cancelled cheque, and photographs. For companies/LLPs, incorporation certificate and MOA/AOA are also required."
  },
  {
    id: 7,
    question: "How do you ensure timely compliance?",
    answer: "We maintain a systematic calendar for all due dates and send proactive reminders to clients. Our team tracks regulatory changes and ensures your business stays compliant with all requirements."
  },
  {
    id: 8,
    question: "Can you help with business advisory beyond compliance?",
    answer: "Absolutely! We provide strategic advisory on financial planning, business structuring, tax optimization, and growth strategies tailored to your business goals and industry."
  }
];

export const ctaButtons = {
  bookConsultation: "Book Free Consultation",
  callNow: "Call Now",
  whatsApp: "WhatsApp Us",
  getStarted: "Get Started",
  learnMore: "Learn More"
};
